module.exports = __webpack_public_path__ + "img/package_back.47986cc4.jpg";